import React from 'react'
import confluenceImg from '../images/team.png'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <img src={confluenceImg} alt="" style={{marginTop:"20px"}}/>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Kenputer</h1>
                <p>Say hello to the Atlassian Confluence.</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('intro')}}>Calc Macro</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('work')}}>Find and Replace</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('sla')}}>SLA</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('eula')}}>END-USER LICENSE AGREEMENT</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>About</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: React.PropTypes.func,
    timeout: React.PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js